import { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { useParams, useNavigate } from "react-router-dom";
import { handleResetPassword } from "../Dashboard/ApiHandler/authFunctions";

function ResetPassword() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { token } = useParams();
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            toast.error("Passwords do not match", { position: "top-center" });
            return;
        }
        await handleResetPassword(e, token, password, confirmPassword, setPassword, setConfirmPassword, setLoading);
        // After successful reset, the toast is shown. We can delay a redirect.
        setTimeout(() => navigate('/'), 2000);
    };

    return (
        <>
            <ToastContainer />
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #f6f8fd 0%, #f1f5f9 100%)',
                fontFamily: "'Inter', sans-serif"
            }}>
                <div style={{
                    background: '#ffffff',
                    padding: '40px',
                    borderRadius: '20px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
                    width: '100%',
                    maxWidth: '420px',
                    textAlign: 'center'
                }}>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        background: 'rgba(102, 126, 234, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 20px auto'
                    }}>
                        <i className="bx bx-lock-open-alt" style={{ fontSize: '28px', color: '#667eea' }}></i>
                    </div>
                    <h1 style={{ margin: '0 0 10px 0', fontSize: '24px', color: '#2d3748' }}>Set New Password</h1>
                    <p style={{ margin: '0 0 30px 0', fontSize: '14px', color: '#718096' }}>
                        Your new password must be different from previous used passwords.
                    </p>

                    <form onSubmit={onSubmit} style={{ textAlign: 'left' }}>
                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: '600', color: '#4a5568' }}>New Password</label>
                            <input
                                type="password"
                                placeholder="Enter new password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: '1.5px solid #e2e8f0',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    outline: 'none',
                                    boxSizing: 'border-box',
                                    transition: 'border 0.2s'
                                }}
                                onFocus={e => e.target.style.border = '1.5px solid #667eea'}
                                onBlur={e => e.target.style.border = '1.5px solid #e2e8f0'}
                            />
                        </div>
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: '600', color: '#4a5568' }}>Confirm Password</label>
                            <input
                                type="password"
                                placeholder="Confirm new password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: '1.5px solid #e2e8f0',
                                    borderRadius: '10px',
                                    fontSize: '14px',
                                    outline: 'none',
                                    boxSizing: 'border-box',
                                    transition: 'border 0.2s'
                                }}
                                onFocus={e => e.target.style.border = '1.5px solid #667eea'}
                                onBlur={e => e.target.style.border = '1.5px solid #e2e8f0'}
                            />
                        </div>
                        <button 
                            type="submit" 
                            disabled={loading}
                            style={{
                                width: '100%',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '14px',
                                borderRadius: '10px',
                                fontSize: '15px',
                                fontWeight: '700',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                boxShadow: '0 4px 14px rgba(102, 126, 234, 0.4)',
                                transition: 'all 0.2s ease',
                                opacity: loading ? 0.7 : 1
                            }}
                            onMouseEnter={e => { if(!loading) { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.5)'; } }}
                            onMouseLeave={e => { if(!loading) { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 14px rgba(102, 126, 234, 0.4)'; } }}
                        >
                            {loading ? 'Please wait...' : 'Reset Password'}
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
}

export default ResetPassword;